<template>
    <div class="mask" :class="(loaded)?'mask_fade_out':''">
        <img :src="bean" alt="">
    </div>
    
</template>
<script>
import bean from './assets/bean.png';
export default {
    props: ['loaded'],
    data(){
        return {
            //header_loaded: false,
            bean
        }
        
    },
    mounted(){
        setTimeout(()=>{
            //this.header_loaded = true;

        },1000);
    }
}
</script>
<style lang="sass">

.mask
    position: fixed
    width: 100vw
    height: 100vh
    z-index: 10000
    background: #000
    left: 0
    top: 0
    display: flex
    align-items: center
    justify-content: center
    transition: .3s
    opacity: 1
    img
        width: 50px
        height: 50px
        animation: 1.5s infinite scale

.mask_fade_out
    opacity: 0
    pointer-events: none
</style>



// WEBPACK FOOTER //
// src/Mask.vue